/**
 * Hook de estado del formulario y navegación entre pasos.
 *
 * No conoce APIs ni cálculos monetarios — solo el shape de los valores y
 * el activeStep.
 */

import { useEffect, useState } from 'react';
import { getHotelInputDateTime } from 'utils/timeZone';
import { STEPS, TOTAL_STEPS, emptyCustomer } from '../constants';

const buildInitialValues = () => ({
  roomType: '',
  roomNo: '',
  stayType: 'night',
  checkInDate: getHotelInputDateTime(5),
  checkOutDate: '',
  numberOfNights: 1,
  paymentMethod: '',
  advanceAmount: '',
  totalAmount: '',
  paymentCurrency: '',
  exchangeRateUsed: '',
  amountInForeignCurrency: '',
  batchNumber: '',
  transactionNumber: '',
  createdBy: '',
  customers: [emptyCustomer()]
});

export const useReservationForm = (selectedRoomData) => {
  const [activeStep, setActiveStep] = useState(STEPS.ROOM);
  const [initialValues, setInitialValues] = useState(buildInitialValues);

  // Cuando se conoce la habitación seleccionada, propagamos los valores
  // visibles del formulario para que Formik reinicialice con ellos.
  useEffect(() => {
    setInitialValues((prev) => ({
      ...prev,
      roomType: selectedRoomData?.roomType || '',
      roomNo: selectedRoomData?.roomNo || ''
    }));
  }, [selectedRoomData]);

  const goNext = () => setActiveStep((step) => Math.min(step + 1, TOTAL_STEPS - 1));
  const goBack = () => setActiveStep((step) => Math.max(step - 1, 0));
  const getProgress = () => ((activeStep + 1) / TOTAL_STEPS) * 100;

  return {
    activeStep,
    setActiveStep,
    initialValues,
    setInitialValues,
    handleNext: goNext,
    handleBack: goBack,
    getProgress
  };
};
